import AdminSidebar from '../components/admin/AdminSidebar';
import AdminHeader from '../components/admin/AdminHeader';
import AdminStatsComponent from '../components/admin/AdminStats';
import '../styles/admin.css';

export default function AdminStats() {
  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="admin-content">
        <AdminHeader 
          title="Statistiques" 
          subtitle="Vue d'ensemble de votre activité"
        />
        <AdminStatsComponent />
      </div>
    </div>
  );
}